import {
  animate,
  sequence,
  style,
  transition,
  trigger,
} from '@angular/animations';

export const rightColAnimation = [
  trigger('rightColAnimation', [
    transition('void => secondary', [
      style({ opacity: 0 }),
      animate('400ms ease-in-out', style({ opacity: 1 })),
    ]),
    transition('void => primary', [
      sequence([
        style({
          opacity: 0,
          transform: 'translateX(1rem)',
        }),
        animate('0.8s ease', style({ opacity: 1, transform: 'translateX(0)' })),
      ]),
    ]),
    transition('secondary => primary', [
      style({ opacity: 0 }),
      animate('400ms ease-in-out', style({ opacity: 1 })),
    ]),
    transition('primary => secondary', [
      style({ opacity: 0 }),
      animate('240ms ease-in-out', style({ opacity: 1 })),
    ]),
  ]),
];
